import * as admin from '@/modules/admin/paths';
import * as billing from '@/modules/billing/paths';
import * as order from '@/modules/order/paths';
import * as product from '@/modules/product/paths';
import * as retailer from '@/modules/retailer/paths';
import * as store from '@/modules/store/paths';
import * as supplier from '@/modules/supplier/paths';
import { type ModuleName, modules } from '@/routing/modules';

type PathObject = { path: string };
type PathGroup = Record<string, string>;
type PathValue = string | PathObject | PathGroup;
type Paths = Record<string, PathValue>;

export const HomePath = '/';

const basePaths: Paths = {
  home: HomePath,
};

const modulePathMap: Record<ModuleName, Paths> = {
  admin,
  billing,
  order,
  product,
  retailer,
  store,
  supplier,
};

function prefixedPathKey(moduleName: ModuleName, key: string): string {
  return `${moduleName}.${key}`;
}

function buildAllPaths(): Paths {
  const result: Paths = { ...basePaths };

  for (const moduleName of modules) {
    for (const [key, value] of Object.entries(modulePathMap[moduleName])) {
      result[prefixedPathKey(moduleName, key)] = value;
    }
  }

  return result;
}

export const allPaths = buildAllPaths();
